import React from 'react';
import CustomModal from "../../../../../components/Modal/CustomModal";
import {
    IconAvatarTable,
    IconClockTable, IconDeskOfficeTable,
    IconMarkerTable,
    IconScheduleTable,
    PeopleTalking,
    PersonOutlinedChip,
    PersonOutlinedTitle,
    StarCalendarTitle
} from "../../../../../components/buttons/IconButtons";
import CustomChip from "../../../../../components/CustomChip";
import {
    chipStatusClassColor
} from "../../../../../enums/statusColorEnum";
import {status} from "../../../../../enums/statusEnum";
import {colors} from "../../../../../enums/colors";
import CustomCard from "../../../../../components/CustomCard";
import CustomUserChip from "../../../../../components/CustomUserChip";
import {POSITION_MODEL} from "../../../../../Helpers/PositionModel";
import CustomGenericTittleIconDataChip from "../../../../../components/CustomGenericTittleIconDataChip";
import {EMPTY_VALUES, getDateFormat, getFullName, getTimeFormat} from "../../../../../Apis/functions";
import {getFieldTypeById} from "../../Type/Model/Model";
import {InvitationDetailsModalApp} from "../Functionality/InvitationDetailsModalApp";
import {INVITATION_VIEW_TYPE} from "../Model/Model";
import CustomTooltip from "../../../../../components/CustomTooltip";

/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */

const InvitationDetailsModal = (props) => {
    const { onHide, itemSelected, showIdentityValidationButton, viewType } = props;

    const {t, activities, activitiesCount, accessPoints, isOverdue, goRoutes } = InvitationDetailsModalApp(props);

    return (
        <CustomModal
            {...props}
            size='lg'
            buttonConfirm='confirm'
            onHide={() => {
                onHide();
            }}
            confirmButton={false}
            cancelButton={false}
            topLeftHeader={
                <>
                    <div className={"d-flex align-items-center pb-3"}>
                        <StarCalendarTitle/>
                        { viewType === INVITATION_VIEW_TYPE.HISTORY ?
                            <p className={"fs-modal-title font-color-general-950 ml-2"}>
                                {t("invitation_by")} {getFullName(itemSelected?.hostName, itemSelected?.hostLastName, itemSelected?.hostSecondLastName)}
                            </p>
                            :
                            <p className={"fs-modal-title font-color-general-950 ml-2 text-ellipsis"}>{t("my_invitation")}</p>
                        }

                        <div className="vertical-separator h-auto" />
                        <CustomUserChip
                            className={`mt-0 ${chipStatusClassColor[itemSelected?.statusId]}`}
                            name={t(status[itemSelected?.statusId]) || EMPTY_VALUES.DEFAULT}
                            showAvatar={false}
                            variant="large"
                        />

                        { isOverdue &&
                            <CustomUserChip
                                className={`mt-0 ${chipStatusClassColor[isOverdue]}`}
                                name={t(status[isOverdue]) || EMPTY_VALUES.DEFAULT}
                                showAvatar={false}
                                variant="large"
                            />
                        }
                    </div>
                </>
            }
            classNameBody="pt-2"
        >
            <CustomCard classCard={"card-border-8px"} classContent={"p-0"}>
                <PeopleTalking className={"w-100"}/>
                <div className={"row"}>
                    <div className={"col-12 my-4"}>
                        <div className={"d-flex justify-content-between align-items-center"}>
                            <div className={"d-flex align-items-center"}>
                                <IconAvatarTable/>
                                <p className={"font-color-general-950 fs-14px ml-2"}>{`${itemSelected?.visitorName} ${itemSelected?.visitorLastName} ${itemSelected?.visitorSecondLastName? itemSelected?.visitorSecondLastName: ""}`}</p>
                            </div>
                            <div>
                                <CustomUserChip
                                    className={`mt-0 ${chipStatusClassColor[itemSelected?.visitorStatusId]}`}
                                    name={t(status[itemSelected?.visitorStatusId]) || EMPTY_VALUES.DEFAULT}
                                    showAvatar={false}
                                    variant="large"
                                    iconPosition={POSITION_MODEL.LEFT}
                                />
                                <CustomUserChip
                                    className='mt-0 chip-shades-300-00'
                                    name={"+"+ itemSelected?.visitorNumber}
                                    Icon={PersonOutlinedChip}
                                    showAvatar={true}
                                    classNameText={"ibl-font-w-600"}
                                    variant="large"
                                    iconPosition={POSITION_MODEL.LEFT}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className={"border-bottom-shades-300"}/>

                <div className={"row my-4"}>
                    <div className={"col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6"}>
                        <CustomGenericTittleIconDataChip title={t("date")}/>
                        <div className={"mt-2"}>
                            <div className={" d-flex align-items-center"}>
                                <IconScheduleTable className="icon-color-general-950"/>
                                <p className={"font-color-general-950 fs-14px ml-2"}>
                                    {getDateFormat(itemSelected?.startDate,false)}
                                    &nbsp;{ t("to").toLowerCase() }&nbsp;
                                    {getDateFormat(itemSelected?.endDate,false)}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className={"col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6"}>
                        <CustomGenericTittleIconDataChip title={t("time")}/>
                        <div className={"mt-2"}>
                            <div className={"d-flex align-items-center"}>
                                <IconClockTable className="icon-color-general-950"/>
                                <p className={"font-color-general-950 fs-14px ml-2"}>
                                    {getTimeFormat(itemSelected?.startDate)}
                                    &nbsp;{ t("to").toLowerCase() }&nbsp;
                                    {getTimeFormat(itemSelected?.endDate)}
                                </p>
                            </div>
                            <div className={"d-flex align-items-center"}>
                                <IconClockTable className="icon-color-general-950"/>
                                <p className={"font-color-general-950 fs-14px ml-2"}>
                                    {'+'+itemSelected?.accessToleranceMin}
                                    &nbsp;&nbsp;
                                    {t("min_tolerance").toLowerCase()}
                                </p>
                            </div>
                        </div>
                    </div>

                </div>
                <div className={"row my-4"}>
                    <div className={"col-12"}>
                        {/******* Access zone ***********/}
                        <CustomGenericTittleIconDataChip title={t("access_zone")}/>
                        <div className={"mt-2"}>
                            {itemSelected?.rootFatherZoneName &&
                            <div className={"d-flex"}>
                                <IconMarkerTable className={"mr-8px mb-1"}/>
                                <p className={"font-color-general-950 fs-14px ml-2"}>{itemSelected?.rootFatherZoneName}</p>
                            </div>
                            }
                            <div className={"d-flex"}>
                                {itemSelected?.rootFatherZoneName ?  <IconDeskOfficeTable className={"mr-8px mb-1"}/> : <IconMarkerTable className={"mr-8px mb-1"}/>}
                                <p className={"font-color-general-950 fs-14px ml-2"}>{itemSelected?.zoneName}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col-12"}>
                        {/******* Type of visitor ***********/}
                        <CustomGenericTittleIconDataChip title={t("type_of_visitor")}/>

                        <div className={"row my-2"}>
                            <div className={"col-sm-12 col-md-3 col-xl-3 col-lg-3 col-xl-3 col-xxl-3"}>
                                <div className={"d-flex justify-content-start align-items-center"}>
                                    <div><PersonOutlinedTitle/></div>
                                    <span className={"font-color-general-950 fs-14px ml-2"}>{itemSelected?.visitorType?.name}</span>
                                </div>
                            </div>
                            <div className={"col-sm-12 col-md-9 col-xl-9 col-lg-9 col-xl-9 col-xxl-9 align-items-center"}>
                                <div className={""}>
                                    { itemSelected?.visitorType?.fields?.map(field => {
                                        return   <CustomUserChip
                                            className="m-1 chip-secondary-150-100"
                                            name={t(getFieldTypeById(field?.fieldType)?.name) + (field?.isRequired ? " *": "")}
                                            showAvatar={true}
                                            Icon={getFieldTypeById(field?.fieldType)?.icon}
                                            variant="compact"
                                            iconPosition={POSITION_MODEL.LEFT}
                                            classNameIcon="icon-color-secondary-700"
                                        />
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={"col-12 mb-3"}>
                        {/******* Activity ***********/}

                        <CustomGenericTittleIconDataChip
                            title={t("activity")}
                            badge={
                                <CustomChip
                                    background={colors.shades200}
                                    fontColor={colors.shades500}
                                    borderColor={colors.shades300}
                                    legend={activitiesCount}
                                    variant={'compact'}
                                    className={"chip-badge mb-1"}
                                />
                            }
                        />

                        {Object.entries(activities)?.map(([key, activity], index) => {
                            return <>
                                <div className={`d-flex justify-content-between align-items-center ${activities?.length !== (index+1) ? "my-3": "mt-3"}`}>
                                    <div className={"d-flex align-items-center"}>
                                        <activity.Icon/>
                                        <p className={"font-color-general-950 fs-14px ml-2"}>{t(activity.trans)}</p>
                                    </div>

                                    {activity?.button && activity.button(activity.buttonDisabled, showIdentityValidationButton, () => goRoutes(activity.url, activity.id))}
                                </div>
                                {Object.entries(activities)?.length !== (index+1) && <div className={"border-bottom-shades-300"}/>}
                            </>
                        })}
                    </div>

                    { accessPoints.length > 0 &&
                        <div className={"col-12 mb-3"}>
                        {/******* Access Points ***********/}

                        <CustomGenericTittleIconDataChip title={t("access_points")}/>
                        <div className={`row my-3`}>
                            {Object.entries(accessPoints)?.map(([key, point], index) => {
                                return <div className={"col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 access-point-item"}>
                                    <div className={"align-items-center text-center"}>
                                        {point.deviceType !== null && <CustomTooltip text={t(point.deviceType.transWithDevice)}> <point.deviceType.Icon/></CustomTooltip>}
                                        <CustomTooltip
                                            text={point.zoneName}
                                            classes={"font-color-general-950 ibl-font-w-600 fs-14px text-ellipsis-1-row"}
                                            showIfTruncated={true}
                                            placement={"top"}
                                        />

                                        <CustomTooltip
                                            text={point.deviceName}
                                            classes={"font-color-shades-600 fs-12px text-ellipsis-1-row"}
                                            showIfTruncated={true}
                                            placement={"top"}
                                        />
                                        <div className={"d-flex justify-content-center align-items-center"}>
                                            {point.accessMethod?.Icon !== null &&
                                            <CustomTooltip text={t(point.accessMethod.value)}>
                                                <div className={"access-method-icon"}>
                                                    <point.accessMethod.Icon/>
                                                </div>
                                            </CustomTooltip>}
                                            <CustomChip
                                                className={"ml-2"}
                                                background={colors.shades200}
                                                fontColor={colors.shades700}
                                                borderColor={colors.shades200}
                                                legend={getTimeFormat(point.createdAt)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            })}
                        </div>
                    </div>
                    }
                </div>
            </CustomCard>
        </CustomModal>
    );
};

export default InvitationDetailsModal;
